/**
 * 联系人api
 * date:2022 04 16
 * author：brian
 */
import httpRequest from '@/utils/request.js';

/**获取列表 */
export const contactsList = (params = {}) => httpRequest.httpGet({
    url: '/service/contacts/page', params: {
        ...params
    }
});
/**获取详情 */
export const contactsDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/contacts/detail', params: {
        ...params
    }
});
/**同步数据 */
export const contactsSync = (params = {}) => httpRequest.httpGet({
    url: '/service/contacts/sync', params: {
        ...params
    }
});
/**添加 */
export const contactsAdd = (data) => httpRequest.httpPost('/service/contacts/add', data);
/**修改 */
export const contactsUpdate = (data) => httpRequest.httpPut('/service/contacts/update', data);
/**删除 */
export const contactsDel = (data) => httpRequest.httpdelete2('/service/contacts/del', data);
// /**校验 */
// export const contactsVerify = (data) => httpRequest.httpPost('/service/contacts/verify', data);